import { IXetThucTapActionTypes } from "../../action-types/xet-thuc-tap/IXetThucTapActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IXetThucTapReducer } from "../../reducer-model/xet-thuc-tap/IXetThucTapReducer";

const iniState: IXetThucTapReducer = {
    status: eReducerStatusBase.is_not_initialization,
    id_dot_thuc_tap_xet: 0, // Default value for the internship period ID
    filterLop: {
        id_he: 0,
        id_khoa: 0,
        khoa_hoc: 0,
        id_chuyen_nganh: 0,
        id_lop: 0,
    },
}

export const xetThucTapReducer = (state: IXetThucTapReducer = iniState, action: IXetThucTapActionTypes): IXetThucTapReducer => {
    switch (action.type) {
        case "XET_THUC_TAP_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                isShowProcessing: true,
                processId: action.payload?.progress_id || undefined,
            };
        case "XET_THUC_TAP_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowThamSoModal: false,
            };
        case "XET_THUC_TAP_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "XET_THUC_TAP_XET_THEO_MON_NGHIEP_VU_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                isShowProcessing: true,
                processId: action.payload?.progress_id || undefined,
            };
        case "XET_THUC_TAP_XET_THEO_MON_NGHIEP_VU_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowThamSoModal: false,
            };
        case "XET_THUC_TAP_XET_THEO_MON_NGHIEP_VU_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "XET_THUC_TAP_SHOW_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: true,
                id_dot_thuc_tap_xet: action.payload
            };
        case "XET_THUC_TAP_CLOSE_THAM_SO_MODAL":
            return {
                ...state,
             isShowThamSoModal: false,
            };
        case "XET_THUC_TAP_CLOSE_PROCESSING_MODAL":
            return {
                ...state,
                isShowProcessing: false,
                processId: undefined,
            };
        case "XET_THUC_TAP_CHANGE_FILTER_LOP":
            return {
                ...state,
                filterLop: action.payload,
            };
        default:
            return state;
    }
};